import { gql } from '@apollo/client';

export const FIND_ALL_INDIVIDUALS_BY_PLAN = gql`
  query FindAllIndividualsByPlan($uuid: ID!) {
    findAllIndividualsByPlan(uuid: $uuid) {
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const CREATE_INDIVIDUAL = gql`
  mutation Individual($data: CreateIndividualInput!) {
    createIndividual(data: $data) {
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const UPDATE_INDIVIDUAL = gql`
  mutation Individual($data: UpdateIndividualInput!) {
    updateIndividual(data: $data) {
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const DELETE_INDIVIDUAL = gql`
  mutation DeleteIndividual($uuid: ID!) {
    deleteIndividual(uuid: $uuid) {
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;
